/** 尺寸是字符串 */
import { useMemo } from 'react';
import { theme } from 'antd';
import { lightToken } from '@/theme-tokens';
import { sizeToken } from '@/size-tokens';

type ThemeTokenType = typeof lightToken;
type SizeTokenType = typeof sizeToken;

const useThemeToken = () => {
    const { token } = theme.useToken();

    return useMemo(() => ({ ...token as ((typeof token) & ThemeTokenType & SizeTokenType)   }), [ token ]);
};

export default useThemeToken;
